import type { ReactNode } from 'react';

import { MAIL_CONTENT_KINDS } from 'cpool-constants';
import type { SchemaTemplateResolver_GetSignature, SchemaUserResolver_Get } from 'cpool-tables/backend-resolvers';
import DOMPurify from 'dompurify';

import { formatEtaHeaderFooterSignatureContent } from './utils/formatEtaHeaderFooterSignatureContent';
import type { InputKind } from '../headerFooterTemplate/types';

type Props = {
    contentKind: InputKind;
    signature: SchemaTemplateResolver_GetSignature | null;
    user: SchemaUserResolver_Get | undefined;
};

export const Signature: React.FC<Props> = ({ contentKind, signature, user }) => {
    const convertedSignatureContent: string | Array<ReactNode> = formatEtaHeaderFooterSignatureContent({
        contentKind,
        mailContent: signature,
        user,
    });

    if (contentKind === MAIL_CONTENT_KINDS.MAIL_CONTENT && signature?.data.mailContent) {
        return <div>{convertedSignatureContent}</div>;
    }
    if (contentKind === MAIL_CONTENT_KINDS.MAIL_HTML_CONTENT && signature?.data.mailHTMLContent) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(convertedSignatureContent as string, {
                        ADD_TAGS: ['style'],
                    }),
                }}
            />
        );
    }
    return null;
};
